export const parsePositiveId = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return Math.trunc(parsed);
};

export const FIELD_TYPE_META = Object.freeze({
  url: { icon: "mdi-link-variant" },
  short_text: { icon: "mdi-form-textbox" },
  long_text: { icon: "mdi-text-box-multiple-outline" },
  number: { icon: "mdi-numeric" },
  phone: { icon: "mdi-phone-outline" },
  email: { icon: "mdi-email-outline" },
  date: { icon: "mdi-calendar" },
  checkbox: { icon: "mdi-checkbox-marked-outline" },
  select: { icon: "mdi-form-select" },
});

export const CONTRACT_ITEM_FIELD_TYPE_ORDER = Object.freeze([
  "url",
  "short_text",
  "long_text",
  "number",
  "phone",
  "email",
  "date",
  "checkbox",
  "select",
]);

export const buildEmptyFieldForm = (sortOrder = 1) => ({
  id: null,
  label: "",
  field_type: "url",
  help_text: "",
  is_required: true,
  sort_order: sortOrder,
  save_as_template: false,
  option_labels: [],
  value: "",
});
